import { Popover } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../store/store";
import NotificationPanel from "../components/Notification/NotificationPanel";
import
{
  fetchNotificationsAsync,
  fetchUnreadCountAsync,
} from "../store/reducers/notificationSlice";

export default function NotificationBell()
{
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const unreadCount = useSelector(
    (state: RootState) => state.notificationSlice.unreadCount,
  );

  // Initial unread count on mount
  useEffect(() =>
  {
    // @ts-ignore
    dispatch(fetchUnreadCountAsync());
  }, []);

  const handleOpenChange = (newOpen: boolean) =>
  {
    setOpen(newOpen);

    // Re-fetch list + count every time the panel toggles open
    if (newOpen)
    {
      // @ts-ignore
      dispatch(fetchNotificationsAsync({ skip: 0, limit: 50 }));
      // @ts-ignore
      dispatch(fetchUnreadCountAsync());
    }
  };

  return (
    <Popover
      open={open}
      onOpenChange={handleOpenChange}
      content={<NotificationPanel onClose={() => setOpen(false)} />}
      trigger="click"
      placement="bottomRight"
      overlayClassName="notification-popover"
      getPopupContainer={(triggerNode) => triggerNode.parentElement as HTMLElement}
    >
      <div className="relative cursor-pointer">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#2b3a55] border border-[#35486F] hover:bg-[#33466a] transition">
          <BellOutlined className="text-white text-lg" />
        </div>
        {unreadCount > 0 && (
          <div className={`absolute -top-1 -right-1 ${unreadCount > 9 ? "w-6 h-6" : "w-5 h-5"} bg-[#ff5b3d] rounded-full border-2 border-[#0f172a] flex items-center justify-center`}>
            <span className="text-[10px] text-white font-bold">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          </div>
        )}
      </div>
    </Popover>
  );
}
